/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Permission_Name_Users_WriteInputs */

const en_enum_permission_name_users_write = /** @type {(inputs: Enum_Permission_Name_Users_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Users Write`)
};

const de_enum_permission_name_users_write = /** @type {(inputs: Enum_Permission_Name_Users_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Benutzer Write`)
};

/**
* | output |
* | --- |
* | "Name Users Write" |
*
* @param {Enum_Permission_Name_Users_WriteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_permission_name_users_write = /** @type {((inputs?: Enum_Permission_Name_Users_WriteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Permission_Name_Users_WriteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_permission_name_users_write(inputs)
	return de_enum_permission_name_users_write(inputs)
});